import React from "react";
import {
  Link,
  useNavigate,
  useParams,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useQuery } from "react-query";
import moment from "moment";
import useApi from "../../../hooks/useApi";
import PolicyItemStatus, {
  activeStatus,
} from "../../../widgets/PolicyItemStatus";
import useSortableTableHeader from "../../../hooks/useSortableTableHeader";

const PoliciesTable = ({ policies }) => {
  const { TableHeader } = useSortableTableHeader();

  const headers = [
    { label: "Client", sort: true, field: "title" },
    { label: "Company", sort: true, field: "Company.name" },
    // { label: "Created", sort: true, field: "createdAt" },
    { label: "Expires", sort: true },
    { label: "Status", className: "text-center", sort: true },
    { label: "" },
  ];
  return (
    <table className="table table-striped">
      <TableHeader items={headers} />
      <tbody>
        {policies &&
          policies?.map((policy) => (
            <tr key={policy.id}>
              <td>
                {policy?.Client?.name}
                <br />
                {policy?.title && (
                  <>
                    <span className="text-muted">{policy?.title}</span>
                    <br />
                  </>
                )}

                {policy?.policyNumber && (
                  <span className="text-primary">{policy?.policyNumber}</span>
                )}
                {/* <br />
                {policy?.premium && (
                  <span className="fw-bold text-info">
                    Premium:{policy.policyCurrency}{" "}
                    {Number(policy.premium).toLocaleString("en-US")}
                  </span>
                )} */}
              </td>
              <td>
                {policy?.Company?.name && (
                  <>
                    <span>{policy.Company.name}</span> <br />
                  </>
                )}
                {policy?.Branch?.name && (
                  <>
                    <span>{policy?.Branch?.name}</span>
                    <br />
                  </>
                )}
                <span>
                  {policy?.PolicyType?.name} - {policy?.Product?.name}
                </span>
              </td>
              {/* <td>{moment(policy.createdAt).format("DD/MM/YYYY")}</td> */}
              <td>
                {activeStatus.includes(policy.status) && (
                  <>
                    <span>
                      {moment(policy?.expires).format("DD/MM/YYYY") || ""}
                    </span>
                    <p className="text-muted">
                      {policy?.expires && moment().to(moment(policy?.expires))}
                    </p>
                  </>
                )}
              </td>
              <td className="text-center fs-5">
                <PolicyItemStatus status={policy.status} />
              </td>
              <td className="text-center">
                <div className="d-flex flex-wrap justify-content-center">
                  <div className="btn-group">
                    {/* {policy.canUnderwrite && ( */}
                    <Link
                      to={`/policies/${policy.PolicyId}/item/${policy.id}`}
                      title="View policy"
                      className="btn btn-icon btn-outline-primary"
                    >
                      <i className="bi bi-pencil-square fs-4 text-success"></i>
                    </Link>
                    {/* )} */}
                  </div>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default PoliciesTable;
